import { creatorbaseQueries } from '@round/api';
import { useQuery } from '@tanstack/react-query';

const audioQueryOptions = creatorbaseQueries.tiktokAudio.options.detail;

type Indicator = {
    label: string;
    value: number | null | undefined;
    relativeValue?: number | null;
};

export default function useAudioIndicators(audioId: number | null | undefined) {
    const { data, status, error } = useQuery(audioQueryOptions(audioId));

    const indicators: Indicator[] = [
        {
            label: 'Creations',
            value: data?.video_count,
        },
        {
            label: 'Creations (last 7 days)',
            value: data?.video_count_weekly_change,
            relativeValue: data?.video_count_weekly_change_relative,
        },
        {
            label: 'Daily Creations',
            value: data?.video_count_daily_change,
            relativeValue: data?.video_count_daily_change_relative,
        },
    ];

    return {
        indicators,
        status,
        error,
    };
}
